module.exports = __webpack_public_path__ + "img/5-mob.2d70d786.svg";